import http from '@core/fetch'
import { API_SETMEAL_LIST } from '@constant'
export default {
  //获取所有活动
  getAllActivityApi: body =>
    http('/p/wedding/index.php/Admin/APIMarketingActivity/activity_list', {
      body
    }),
  //获取已报名活动
  getAllJoinActivityApi: body =>
    http('/p/wedding/index.php/Admin/APIMarketingActivity/join_activity_list', {
      body
    }),
  //获取活动详情
  getActivityDetailApi: body =>
    http('/p/wedding/index.php/Admin/APIMarketingActivity/activity_detail', {
      body
    }),
  //获取套餐列表
  getCaseListApi: body =>
    http(API_SETMEAL_LIST, {
      body
    }),
  //获取商家报名的活动位详情
  getPositionInfoApi: body =>
    http(
      '/p/wedding/index.php/Admin/APIMarketingActivity/activity_position_info',
      {
        body
      }
    ),
  // 提交活动套餐
  submitActivityMeal: body =>
    http.post(
      ' /p/wedding/index.php/Admin/APIMarketingActivityMeal/activity_meal',
      { body }
    ),

  // 获取列表活动数
  getActivityCountApi: body =>
    http('/p/wedding/index.php/Admin/APIMarketingActivity/activity_count', {
      body
    }),
  // 取消报名
  cancelActivityMeal: body =>
    http.post(
      ' /p/wedding/index.php/Admin/APIMarketingActivityMeal/cancel_activity_meal',
      { body }
    ),
  // 报名商家类目活动
  applyMerchantActivity: body =>
    http.post(
      '/p/wedding/index.php/Admin/APIMarketingActivityMerchant/activity_merchant',
      { body }
    ),
  // 取消报名商家类目活动
  cancelMerchantActivity: body =>
    http.post(
      '/p/wedding/index.php/Admin/APIMarketingActivityMerchant/cancel_activity_merchant',
      { body }
    )
}
